export default __webpack_public_path__ + "static/media/1.2f6a7440.jpg";